<template>
  <div class="page">
    <div class="query-conditions" style="margin-bottom: 24px;">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <el-form-item>
          <el-input
            v-model="query.form.budget_name"
            clearable
            placeholder="请输入聚合名称"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            v-model="query.form.identify_code"
            clearable
            placeholder="请输入识别名称"
          />
        </el-form-item>

        <el-form-item v-if="showSaler">
          <el-input
            v-model="query.form.owner_name"
            clearable
            placeholder="请输入销售名称"
          />
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="showAssign" label="待分配聚合" border></el-checkbox>
        </el-form-item>
        
        <el-button
          plain
          type="primary"
          :loading="table.loading"
          @click="handleReset"
        >
          重置
        </el-button>

        <el-button
          plain
          type="primary"
          :loading="table.loading"
          @click="handleFilter"
        >
          查询
        </el-button>

        <el-button
          v-if="canAddAggregation"
          type="primary"
          @click="handleEdit('Add')"
        >
          新增聚合
        </el-button>

        <el-button
          type="primary"
          plain
          @click="handleDownload"
        >
          下载
        </el-button>
      </el-form>
    </div>

    <div
      v-loading="table.loading"
      class="query-data"
    >
      <!-- list -->
      <el-table
        stripe
        :data="table.list"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="budget_name"
          label="聚合名称"
        />
        <el-table-column
          prop="identify_code"
          label="识别名称"
        />
        <el-table-column
          prop="sale_type"
          label="预算类型"
          width="120"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.sale_type === '1'">直投</div>
            <div v-else-if="scope.row.sale_type === '2'">渠道</div>
            <div v-else>--</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="products"
          label="主类预算产品"
        >
          <template slot-scope="scope">
            <el-tag 
              v-bind:key="item" 
              type="success" 
              v-for="item in (scope.row.product_names ? scope.row.product_names.split(',') : [])"
              style="margin-right: 8px;"
            >
              {{item}}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          v-if="showSaler"
          prop="owner_name"
          label="销售名称"
          width="120"
        />
        <el-table-column
          prop="agent_name"
          label="代理商"
          width="120"
        />
        <el-table-column
          prop="status"
          label="状态"
          width="120"
        >
         <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === '0'"
              plain
              size="small"
            >
              失效
            </el-button>
            <el-button
              v-else
              type="success"
              plain
              size="small"
            >
              {{ StatusMap[scope.row.status] }}
            </el-button>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          width="250"
        >
          <template slot-scope="scope">
            <div style="margin-bottom: 8px;">
              <el-button
                type="primary"
                plain
                size="small"
                @click="handleEdit('Update', scope.row)"
              >
                修改
              </el-button>
              <el-button
                type="danger"
                plain
                size="small"
                @click="handleUnbind(scope.row)"
              >
                解绑
              </el-button>
              <el-button
                v-if="!scope.row.agent_name"
                type="success"
                plain
                size="small"
                @click="handleCtrlAssign(scope.row)"
              >
                分配
              </el-button>
            </div>
          
            <el-button
              type="primary"
              plain
              size="small"
              @click="handleCtrlCancel(scope.row)"
            >
              {{ scope.row.status === '0' ? '置为有效' : '置为失效' }}
            </el-button>
            <el-button
              type="warning"
              plain
              size="small"
              @click="handleCtrlLogOpen(scope.row)"
            >
              日志
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        :current-page.sync="query.form.page"
        :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes, prev, pager, next"
        :total="table.total"
        style="margin-top: 30px; float: right"
        @size-change="handlePageSizeChange"
        @current-change="handleQueryPage"
      />
    </div>

    <!-- edit -->
    <form-dialog
      :visible.sync="editForm.display"
      :title="(editForm.type === 'Add' ? '新增' : '修改') + '聚合信息'"
      :loading="editForm.loading"
      width="600px"
      @close="handleFormClose"
      @submit="submitEditFormAction"
    >
      <el-form
        ref="editForm"
        :model="editForm.form"
        :rules="editForm.rules"
        label-width="120px"
      >
        <el-form-item
          label="识别名称"
          prop="identify_code"
        >
          <el-input
            v-model="editForm.form.identify_code"
            placeholder="请输入识别名称"
            @blur="handleCompanyName"
          />
        </el-form-item>

        <el-form-item
          label="聚合名称"
          prop="budget_name"
        >
          <el-input
            v-model="editForm.form.budget_name"
            placeholder="请输入聚合名称"
          />
        </el-form-item>
        <div style="margin-left: 120px; margin-bottom: 16px; color: #999;">
          规则：主体商号命名，例如上海XXX网络有限公司，商号：XXX<br/>
          若出现重复，地域+商号，例如上海XXX
        </div>

        <el-form-item
          label="预算类型"
          prop="sale_type"
        >
          <el-select
            v-model="editForm.form.sale_type"
            placeholder="请选择预算类型"
            style="width: 100%;"
          >
            <el-option
              v-for="item in types"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          label="主类预算产品"
          prop="product_ids"
        >
          <el-select
            v-model="editForm.form.product_ids"
            placeholder="输入产品名称"
            style="width: 100%;"
            clearable
            filterable
            multiple
            remote
            reserve-keyword
            :remote-method="handleSearchProducts"
          >
            <el-option
              v-for="item in productOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>

        <el-form-item
          v-if="isAdmin"
          label="所属"
          prop="owner"
        >
          <el-select
            v-model="editForm.form.owner"
            filterable
            multiple
            clearable
            remote
            :remote-method="_searchSalors"
            placeholder="输入并选择所属"
            :loading="editProdSalorDlg.searchLoading"
            style="width: 100%"
          >
            <el-option
              v-for="item in editProdSalorDlg.options"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item 
          label="代理商" 
          prop="agent_name"
          v-if="isAdmin"
        >
          <el-input
            v-model="editForm.form.agent_name"
            placeholder="输入代理商"
          />
        </el-form-item>
      </el-form>
    </form-dialog>

    <!-- unbind -->
    <form-dialog
      :visible.sync="unbindForm.display"
      title="提示"
      width="600px"
      @close="() => { unbindForm.display = false; unbindForm.form = {} }"
      @submit="handleUnbindConfirm"
    >
      是否确认解绑？
    </form-dialog>

    <!--日志-->
    <el-dialog
      title="日志"
      :visible.sync="logVisible"
    >
      <el-table
        :data="logList"
      >
        <el-table-column
          label="操作时间"
          prop="create_time"
        />
        <el-table-column
          label="操作编号"
          prop="id"
        />
        <el-table-column
          label="操作人"
          prop="operator"
        />
        <el-table-column
          label="操作内容"
          prop="content"
        />
      </el-table>
      <div style="margin-top: 10px; text-align: right;">
        <el-pagination
          background
          layout="prev, pager, next"
          :current-page="logPage"
          :page-size="logPageSize"
          :total="logTotal"
          @current-change="handleChangeLogPage"
        />
      </div>
    </el-dialog>

  </div>
</template>

<script>
import Request from '@/core/QuRequest';
import { FormDialog } from '@/components';

const req = new Request();
let self;
export default {
  name: 'AggregationManageMy',
  components: { FormDialog },
  data() {
    return {
      showAssign: false,
      StatusMap: {
        1: '有效',
        0: '失效'
      },
      userInfo: {},
      unbindForm: {
        form: {},
        display: false
      },
      productOptions: [],
      table: {
        list: [],
        total: 0,
        loading: false,
      },
      query: {
        form: {
          budget_name: '',
          page: 1,
          page_size: 10,
          identify_code: '', // 识别名称
          owner_name: '', // 销售名称
        },
      },
      editForm: {
        display: false,
        loading: false,
        type: 'Add',
        form: {
          id: '',
          budget_name: '',
          identify_code: '',
          sale_type: '',
          products_ids: [],
          agent_name: '',
          owner: [],
          owner_name: '',
        },
        rules: {
          budget_name: [
            {
              required: true,
              message: '聚合名称必填',
              type: 'string',
              triggle: 'blur',
            },
            { min: 2, message: '长度必须大于 2 个字符', trigger: 'blur' }
          ],
          identify_code: [
            {
              required: true,
              message: '识别名称必填',
              type: 'string',
              triggle: 'blur',
            },
            { 
              pattern: /^[\u4e00-\u9fa5]+$/,
              message: '只能输入中文',
              trigger: 'blur'
            },
            { min: 2, message: '长度必须大于 2 个字符', trigger: 'blur' }
          ],
          sale_type: [
            {
              required: true,
              message: '预算类型必选',
              triggle: 'blur',
            },
          ],
          product_ids: [
            {
              required: true,
              message: '主类预算产品必选',
              triggle: 'blur',
              type: 'array'
            },
          ],
        },
      },
      editProdSalorDlg: {
        searchLoading: false,
        options: [],
        form: {
          customer_id: '',
          product_id: '',
        },
      },
      logVisible: false,
      logId: '',
      logList: [],
      logTotal: 0,
      logPage: 1,
      logPageSize: 10,
    };
  },
  computed: {
    types() {
      if(this.userInfo.role_ids) {
        if (this.userInfo.role_ids.includes("1")) {
          return [
            {label: '直投', value: '1'}, 
            {label: '渠道', value: '2'}, 
          ]
        }
        if (this.userInfo.role_ids.includes("2") ||  this.userInfo.role_ids.includes("3")) {
          return [
            {label: '渠道', value: '2'}, 
          ]
        }
        return []
      }
      return []
    }, 

    perms() {
      return this.$store.state.perms;
    },

    showSaler(){
      if(this.userInfo.role_ids) {
        return this.userInfo.role_ids.includes("3") ||  this.userInfo.role_ids.includes("1")
      }
      return false
    },

    canAddAggregation() {
      if(this.userInfo.role_ids) {
        // 1:超管，2是直客销售  3是直客销售leader
        return  this.userInfo.role_ids.includes("1") || this.userInfo.role_ids.includes("2") || this.userInfo.role_ids.includes("3")
      }
      return false
    },

    isAdmin() {
      if(this.userInfo.role_ids) {
        // 1:超管，2是直客销售  3是直客销售leader
        return  this.userInfo.role_ids.includes("1")
      }
      return false
    },
  },
  created() {
    this._getList();
    this.getUserInfo();
  },
  methods: {
    async handleDownload() {
      try {
        const res = await req.send(req.Apis.customer.budgetBind.download, {});
        if (res.code === 200) {
          const url = res.data.url;
          if(url) {
            const a = document.createElement('a')
            a.href = url
            a.download = '聚合预算列表.csv'
            a.click()
          }
          
        }
      } catch (err) {
        this.$message.error(`${err.message || '未知错误'}`);
      }
    },
    handleCompanyName() {
      const compantName = this.editForm.form.identify_code || '';
      const budgetName = this.editForm.form.budget_name || '';
      if (compantName && budgetName.trim() === '') {
        const suffixPattern = /(?:有限责任公司|有限公司|股份有限公司|股份公司|（普通合伙）|（特殊普通合伙）|（有限合伙）|（个人独资）|专业合作社|分公司)$/;
        this.editForm.form.budget_name = compantName.replace(suffixPattern, '');
      }
    },
    async getLogList() {
      try {
        const { data } = await req.send(req.Apis.customer.budgetBind.log, {
          config_id: this.logId,
          page: this.logPage,
          page_size: this.logPageSize,
          type: 2,
        });
        this.logList = data.list;
        this.logTotal = Number(data.total);
      } catch (err) {}
    },
    handleChangeLogPage(n) {
      this.logPage = n;
      this.getLogList();
    },
    // 操作按钮: 日志
    handleCtrlLogOpen(row) {
      this.logVisible = true;
      this.logId = row.id;
      this.getLogList();
    },
    // 操作按钮: 分配
    async handleCtrlAssign(row) {
      const params = { id: row.id };
      await req.send(req.Apis.customer.budgetBind.assign, params);
      this.$message.success('操作成功');
      this._getList();
    },
    // 操作按钮: 失效&有效
    handleCtrlCancel(row) {
      this.$confirm('确定操作吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        try {
          await req.send(req.Apis.customer.budgetBind.review, { id: row.id });
          this.$message.success('操作成功');
          this._getList();
        } catch (err) {}
      });
    },
    // 输入并选择销售名称下拉框
    async _searchSalors(key) {
      if (!key) return [];
      try {
        this.editProdSalorDlg.searchLoading = true;
        const res = await req
          .send(req.Apis.customer.common.sales, {
            is_budget: 1,
            names: key,
          })
          .fin(() => {
            this.editProdSalorDlg.searchLoading = false;
          });
        this.editProdSalorDlg.options = res.data.data || [];
      } catch (err) {
        this.$message.error(`获取销售失败：${err.message || '未知错误'}`);
      }
    },
    async getUserInfo() {
      const res = await req.send(req.Apis.sales.user.userInfo);
      if (res.code === 200) {
        this.userInfo = res.data;
      }
    },
    async handleSearchProducts(val){
      const res = await req.send(req.Apis.customer.productSeries.products, {
        names: val,
        page: 1,
        page_size: 100,
      });
      if(res.code === 200) {
        const {data} = res;
        this.productOptions = (data.data || []).map(item => {
          return {label: item.name, value: item.id}
        })
      }
    },

    // 获取用户列表数据
    async _getList(option = {}) {
      try {
        let _query = this.query.form;
        const params = {
          // page: _query.page,
          // page_size: _query.page_size,
          ..._query,
          ...option
        };
        if(this.showAssign) {
          params.agent_name = '';
        }

        this.table.loading = true;
        // req
        const res = await req
          .send(req.Apis.customer.aggregation.list, params)
          .fin(() => {
            this.table.loading = false;
          });
        const dv = res.data || {};
        this.table.list = [...(dv.list || [])];
        this.table.total = Number(dv.total || 0);
      } catch (err) {
        this.$message.error(`获取用户列表失败：${err.message || '未知错误'}`);
      }
    },

    // async 添加/编辑
    async processEdit() {
      try {
        this.editForm.loading = true;

        const params = {
          ...this.editForm.form,
          product_ids: this.editForm.form.product_ids ? this.editForm.form.product_ids.join(',') : [],
          is_owner: 1,
          // owner_name: this.editForm.form.owner_name,
          // owner: this.editForm.form.owner.join(','),
        };
        if(this.isAdmin) {
          params.owner = this.editForm.form.owner.join(',')
        }
        const api =
          req.Apis.customer.aggregation[
            this.editForm.type === 'Add' ? 'add' : 'update'
          ];
        await req.send(api, params).fin(() => {
          this.editForm.loading = false;
        });

        this._getList(); // 刷新列表
        this.editForm.display = false;
      } catch (err) {
        this.editForm.loading = false;
        // this.$message.error(`编辑失败：${err.message || '未知错误'}`);
      }
    },

    // 关闭form弹窗时重置一下校验，不要让上一个form的校验提示保留到下一个弹窗
    handleFormClose() {
      this.$refs.editForm.resetFields();
    },

    // 筛选
    handleFilter() {
      this.query.form.page = 1;
      this._getList();
    },

    handleReset() {
      this.query.form.budget_name = '';
      this.query.form.identify_code = '';
      this.query.form.owner_name = '';   
    },
    // 页量改变
    handlePageSizeChange(pageSize) {
      this.query.form.page_size = Number(pageSize);
      this._getList();
    },

    // 页码改变
    handleQueryPage(page) {
      this.query.form.page = Number(page);
      this._getList();
    },

    // 编辑弹窗
    // eslint-disable-next-line camelcase
    handleEdit(
      type = 'Add',
      { id, budget_name, product_ids, identify_code, product_names, sale_type, 
        owner, owner_name, agent_name 
      } = {},
    ) {
      this.editForm.type = type || 'Add';
      this.editForm.form = {
        id,
        budget_name,
        product_ids: product_ids && typeof product_ids === 'string' ? product_ids.split(',') : [],
        identify_code,
        sale_type: (parseInt(sale_type) || '') + '',
        owner: [],
        agent_name: ''
      };

      if(this.isAdmin) {
        this.editForm.form.owner = owner ? owner.split(",") : [];
        this.editForm.form.agent_name = agent_name;
      }
      this.editForm.display = true;

      if (product_names) {
        this.handleSearchProducts(product_names)
      }
      if (owner_name && this.isAdmin) {
        this._searchSalors(owner_name)
      }
    },

    // 解绑弹窗
    handleUnbind(item = {}) {
      this.unbindForm.form = {
        ...item
      };
      this.unbindForm.display = true;
    },
    // 确认解绑
    async handleUnbindConfirm() {
      try {
        const params = {
          id: this.unbindForm.form.id
        };

        this.table.loading = true;
        // req
        const res = await req
          .send(req.Apis.customer.aggregation.unbind, params)
          .fin(() => {
            this._getList();
            this.table.loading = false;
          });
        this.unbindForm.form = {};
        this.unbindForm.display = false;
      } catch (err) {
        this.$message.error(`解绑失败：${err.message || '未知错误'}`);
      }
    },
    // 提交编辑
    submitEditFormAction() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          this.processEdit();
        } else {
          return false;
        }
      });
    },
  },
};

</script>

<style lang="less" scoped>
.query-data {
  // table
  .query-table {
    position: relative;
    overflow: hidden;
  }
}
</style>
